/* eslint-disable no-shadow */
import axiosUserInstance from '@/helpers/http-common';
import * as Sentry from '@sentry/vue';
import compareVersions from 'compare-versions';

const state = () => ({
  platform: null,
  enviroment: '',
  uuid: null,
  appVersion: null,
  requiredMinVersion: null,
  appStoreLink: null,
});

// getters
const getters = {
  isProduction: state => state.enviroment === 'production',
  isBrowser: state => state.platform === 'browser',
  isIos: state => state.platform === 'ios',
  hasToUpdate: state => Boolean(state.appVersion) &&
    Boolean(state.requiredMinVersion) &&
    Boolean(state.appStoreLink) &&
    compareVersions(state.appVersion, state.requiredMinVersion) < 0,
};

  // actions
const actions = {
  init({ commit, dispatch }, { platform = 'browser', uuid = null }) {
    const formattedPlatform = platform ? platform.toLowerCase() : null;

    commit('init', { platform: formattedPlatform, uuid, enviroment: process.env.NODE_ENV });

    if (window.cordova) {
      dispatch('initSentry');

      window.cordova.getAppVersion.getVersionNumber((version) => {
        commit('updateAppVersion', version);

        dispatch('syncAppDeviceDetails');
      });
    }
  },
  initSentry({ state }) {
    Sentry.init({
      dsn: 'https://72375af0fecf4b9982ab2d801e89b4fd@o588971.ingest.sentry.io/5804004',
      environment: process.env.NODE_ENV,
      tracesSampleRate: 0.3,
    });
    Sentry.setTag('platform', state.platform);
  },
  // TO-DO: do this in registerLogin too
  syncAppDeviceDetails({ state, getters, rootGetters, commit }) {
    if (!getters.isBrowser && rootGetters['auth/isAuthenticated']) {
      axiosUserInstance.post(`user-device-app-info/${state.uuid}`, {
        app_version: state.appVersion,
      })
        .then((response) => {
          commit('updateRequiredMinVersion', response.data.required_app_min_version);

          if (state.platform === 'android') {
            commit('updateAppStoreLink', response.data.android_app_link);
          } else if (state.platform === 'ios') {
            commit('updateAppStoreLink', response.data.ios_app_link);
          }
        })
        .catch((err) => {
          Sentry.captureException(err);
        });
    }
  },
};

  // mutations
const mutations = {
  init(state, { platform, uuid, enviroment }) {
    state.platform = platform;
    state.enviroment = enviroment;
    state.uuid = uuid;
  },
  updateAppVersion(state, appVersion = null) {
    state.appVersion = appVersion;
  },
  updateRequiredMinVersion(state, requiredMinVersion = null) {
    state.requiredMinVersion = requiredMinVersion;
  },
  updateAppStoreLink(state, appStoreLink = null) {
    state.appStoreLink = appStoreLink;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/device.js